import { render, staticRenderFns } from "./IncomingCallDisplaySetting.vue?vue&type=template&id=084dfe15&"
import script from "./IncomingCallDisplaySetting.vue?vue&type=script&lang=js&"
export * from "./IncomingCallDisplaySetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports